import styled, { css } from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

import { ButtonWrapper } from '../Button/Button.styles'

export type ModalVariant = 'default' | 'full'

export const ModalBackdrop = styled.div`
  ${Cover()}
  background-color: ${props => props.theme.color.primaryDark};
  opacity: 0.4;

  ${props =>
    props.theme.contrastMode &&
    css`
      background-color: ${props => props.theme.color.global};
    `};
`

export const ModalIcon = styled.div`
  svg {
    display: block;
    height: 14rem;
    width: auto;
    fill: ${({ theme }) => theme.color.global};
    margin-bottom: 3rem;

    .primary {
      fill: var(--color-primary);
    }
  }
`

export const ModalDialog = styled.div`
  position: relative;
  z-index: 3;
  box-shadow: 0px 4px 174px rgba(0, 20, 137, 0.2);
  overflow: hidden;
  background-color: ${props => props.theme.color.body};
`

interface ModalWrapperProps {
  $variant: ModalVariant
}

export const ModalBody = styled.div``

export const ModalWrapper = styled.div<ModalWrapperProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  bottom: 0;
  z-index: 150;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  overflow: auto;

  ${props =>
    props.$variant === 'default' &&
    css`
      ${ModalDialog} {
        text-align: center;
        justify-content: center;
        width: 46rem;
        max-width: 90%;

        ${ButtonWrapper} {
          &:not(:last-child) {
            margin-right: 0.5rem;
          }
        }
      }

      ${ModalBody} {
        padding: ${props => props.theme.outerMargin};
        padding: 4rem;
      }
    `};

  ${props =>
    props.$variant === 'full' &&
    css`
      padding: 0;
      align-items: flex-end;

      ${ModalDialog} {
        width: 100%;
        max-width: 100%;
        padding: 0;
        text-align: left;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        max-height: 100vh;
      }

      ${ModalBody} {
        background-color: ${props => props.theme.color.light};
        padding: ${props => props.theme.outerMargin};
        overflow: auto;

        ${props =>
          props.theme.accessibilityMode &&
          css`
            max-height: 50vh;
          `};
      }
    `};
`

export const ModalClose = styled.div`
  ${Reset('button')}
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  ${Reset('button')}
  width: 3rem;
  height: 3rem;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid var(--color-global);
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${TransitionPrimary('background-color', 'color')}

  &:hover {
    background-color: var(--color-global);
    color: var(--color-light);
  }

  svg {
    width: 1.5rem;
    fill: currentColor;
    display: block;
  }
`

export const ModalFooter = styled.div`
  padding: 1.5rem;
`
